"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userTypeInStringFormat = exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType[UserType["Student"] = 3] = "Student";
    UserType[UserType["Academic"] = 1] = "Academic";
    UserType[UserType["HealthcareProvider"] = 2] = "HealthcareProvider";
    UserType[UserType["AlternativePractitioner"] = 4] = "AlternativePractitioner";
    UserType[UserType["Enthusiast"] = 5] = "Enthusiast";
})(UserType || (exports.UserType = UserType = {}));
exports.userTypeInStringFormat = {
    [UserType.Academic]: 'academic',
    [UserType.HealthcareProvider]: 'healthcareProvider',
    [UserType.Student]: 'student',
    [UserType.AlternativePractitioner]: 'alternativePractitioner',
    [UserType.Enthusiast]: 'enthusiast',
};
